import { isEmpty, size } from 'lodash';
import { connect } from 'react-redux';

import CollectionFilterToggle from 'components/CollectionFilterToggle';
import * as actions from 'state/actions';
import CollectionPage from 'state/selectors/collection-page';

const mapStateToProps = (state, ownProps) => {
  const filterOptions = CollectionPage.getAppliedFilterOptions(state);
  const appliedFilterAmount = size(filterOptions);

  return { appliedFilterAmount, ...ownProps };
};

const mapDispatchToProps = dispatch => ({
  onClick: experimentEngagementIdentifiers => {
    dispatch(actions.openCollectionPageFilterDrawer());

    if (!isEmpty(experimentEngagementIdentifiers)) {
      dispatch(
        actions.trackEngagementClick({
          eventCategory: 'Collection Page',
          eventAction: 'Filter Drawer Open',
          eventLabel: 'Filter Drawer Open',
          ...experimentEngagementIdentifiers,
        })
      );
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CollectionFilterToggle);
